(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new"] && !Shopify.designMode) return;
  try {
    
let index = 0;
const slides = document.querySelector(".hero-wrapper");
const dots = document.querySelectorAll(".dot");

function showSlide(i) {
  index = i;
  slides.style.transform = `translateX(-${i * 100}%)`;
  dots.forEach(dot => dot.classList.remove("active"));
  dots[i].classList.add("active");
}

// Auto slide every 3 sec
setInterval(() => {
  index = (index + 1) % 3;
  showSlide(index);
}, 3000);

// Dot click
dots.forEach((dot, i) => {
  dot.addEventListener("click", () => showSlide(i));
});

// Swipe
let startX = 0;

slides.addEventListener("touchstart", e => startX = e.touches[0].clientX);
slides.addEventListener("touchend", e => {
  let diff = e.changedTouches[0].clientX - startX;

  if (diff > 50 && index > 0) showSlide(index - 1);
  if (diff < -50 && index < 2) showSlide(index + 1);
});

  } catch(e) { console.error(e); }
})();
})();
